import { render, staticRenderFns } from "./huawei.vue?vue&type=template&id=16b3b5c4&"
import script from "./huawei.vue?vue&type=script&lang=js&"
export * from "./huawei.vue?vue&type=script&lang=js&"
import style0 from "./huawei.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports